import React from 'react';
import { Spinner } from '../../spinner/Spinner';

import styles from './Overlay.module.scss';

export const Overlay: React.FC = () => {
  return (
    <div className={styles.DashboardOverlay}>
      <Spinner />
      <div className={styles.DashboardOverlayLabel}>We are analyzing your org setup. Initial scan may take longer. You can safely close the screen or log out. Scan will run in the background and you'll receive an email when the report is ready.</div>
    </div>
  );
}
